import {
    SET_MY_COVERAGE_DATA
} from './types';

const setMyCoverageData = (myCoverageData: any) => ({
    type: SET_MY_COVERAGE_DATA,
    myCoverageData
});

export {
    setMyCoverageData
};
